<template>
    <div class="item">
        <img v-bind:src="testimonial.src" alt="Image" style="width: 80px;">
        <div class="review_content">
            <p>{{ description }}</p>
            <div class="review_rating">
                <i v-for="(n, index) in new Array(5)" v-bind:class="{ 'fa-star' : (index+1)<=testimonial.rating, 'fa-star-o' : (index+1)>testimonial.rating }" class="fa" aria-hidden="true"></i>
            </div>
            <div class="review_author">{{ title }}</div>
        </div>
    </div>
</template>
<script>
    export default {
        props : [ 'testimonial' ],
        computed : {
            title : function(){
                return this.testimonial.title[this.$language];
            },
            description : function(){
                return this.testimonial.subtitle[this.$language];
            }
        }
    };
</script>


// WEBPACK FOOTER //
// Testimonial.vue?02cb2c70